import { render, staticRenderFns } from "./vsTh.vue?vue&type=template&id=d6b55f7a"
import script from "./vsTh.vue?vue&type=script&lang=js"
export * from "./vsTh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports